<script>
import baseMixin from '@/mixins/baseMixin'

export default {
  name: 'TimesheetExpansionPanelHeaderStatistic',
  mixins: [baseMixin],
  props: {
    pendingApprovalCount: {
      type: Number,
      default: 0,
    },
    approvedCount: {
      type: Number,
      default: 0,
    },
    pendingReviewCount: {
      type: Number,
      default: 0,
    },
  },
}
</script>

<template>
  <div>
    <div class="d-inline-block mr-5">
      <v-tooltip top>
        <template v-slot:activator="{ attrs, on }">
          <v-icon small class="mr-2" v-bind="attrs" v-on="on">
            mdi-file-multiple
          </v-icon>
        </template>
        <span>
          {{ $t('timesheets.statIcon.pendingApprovalTooltipText') }}
        </span>
      </v-tooltip>
      <span data-testid="timesheet-panel-stat-pending-approval-count">
        {{ pendingApprovalCount }}
      </span>
    </div>
    <div class="d-inline-block mr-5">
      <v-tooltip top>
        <template v-slot:activator="{ attrs, on }">
          <v-icon small class="purple--text mr-2" v-bind="attrs" v-on="on">
            mdi-check-decagram
          </v-icon>
        </template>
        <span>
          {{ $t('timesheets.statIcon.approvedTooltipText') }}
        </span>
      </v-tooltip>
      <span
        data-testid="timesheet-panel-stat-approved-count"
        class="purple--text"
      >
        {{ approvedCount }}
      </span>
    </div>
    <div class="d-inline-block mr-5">
      <v-tooltip top>
        <template v-slot:activator="{ attrs, on }">
          <v-icon small class="blue--text mr-2" v-bind="attrs" v-on="on">
            mdi-magnify
          </v-icon>
        </template>
        <span>
          {{ $t('timesheets.statIcon.pendingReviewTooltipText') }}
        </span>
      </v-tooltip>
      <span
        data-testid="timesheet-panel-stat-pending-review-count"
        class="blue--text"
      >
        {{ pendingReviewCount }}
      </span>
    </div>
  </div>
</template>
